export const BEGIN_AJAX_CALL = '@@ajax/BEGIN_AJAX_CALL';
export const END_AJAX_CALL = '@@ajax/END_AJAX_CALL';
export const AJAX_CALL_ERROR = '@@ajax/AJAX_CALL_ERROR';
